<template>
	<el-dialog
		:custom-class="`${verticalCenter ? 'vertical-center' : ''} ${$attrs['custom-class']}`"
		v-bind="$attrs"
		v-on="$listeners"
	>
		<template v-if="$slots.title" #title>
			<slot name="title"></slot>
		</template>

		<slot></slot>

		<template v-if="$slots.footer" #footer>
			<slot name="footer"></slot>
		</template>

		<template v-else-if="operates && operates.length > 0" #footer>
			<div>
				<template v-for="(operate, index) in operates">
					<el-button :key="index" @click="operate.click" v-bind="operate">
						{{ operate.label }}
					</el-button>
				</template>
			</div>
		</template>
	</el-dialog>
</template>

<script>
/**
 * 自定义Dialog组件（符合当前ui样式）
 * @param {Boolean} verticalCenter - 是否垂直居中显示
 *
 * @slot title - dialog标题
 * @slot footer - dialog底部
 *
 * 支持el-dialog的所有属性和事件
 */
export default {
	name: "XbdDialog",
	inheritAttrs: false,
	props: {
		/**
		 * 是否垂直居中显示， 默认为true
		 * 垂直显示时dialog的top熟悉不生效
		 */
		verticalCenter: {
			type: Boolean,
			default: true
		},
		operates: {
			type: Array,
			default: () => []
		}
	}
};
</script>

<style lang="scss" scoped>
::v-deep .vertical-center {
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	margin: 0px !important;
}

::v-deep .el-dialog .el-dialog__header {
	padding: 16px 24px;
	border-bottom: 1px solid #e7e8eb;

	> span {
		font-family: PingFang SC;
		font-weight: 600;
		font-size: 16px;
		color: #252a33;
		line-height: 24px;
		text-align: left;
		font-style: normal;
		text-transform: none;
	}
}

::v-deep .el-dialog__body {
	padding: 24px;
}

::v-deep .el-dialog__footer {
	padding: 12px 24px;
	border-top: 1px solid #e7e8eb;
}
</style>
